 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLEPAGE from '@/components/titlepage'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_000 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_000'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_001 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_001'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_002 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_002'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_003 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_003'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_004 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_004'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_005 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_005'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_006 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_006'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_007 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_007'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_008 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_008'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_009 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_009'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_010 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_010'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_011 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_011'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_012 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_012'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_013 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_013'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_014 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_014'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_015 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_015'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_016 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_016'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_017 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_017'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_018 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_018'
 import TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_019 from '@/components/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_019'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/titlepage",
 			"name" : "titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_000",
 			"name" : "tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_000",
 			"component" : TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_000
 		},
 		{
 			"path" : "/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_001",
 			"name" : "tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_001",
 			"component" : TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_001
 		},
 		{
 			"path" : "/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_002",
 			"name" : "tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_002",
 			"component" : TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_002
 		},
 		{
 			"path" : "/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_003",
 			"name" : "tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_003",
 			"component" : TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_003
 		},
 		{
 			"path" : "/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_004",
 			"name" : "tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_004",
 			"component" : TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_004
 		},
 		{
 			"path" : "/tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_005",
 			"name" : "tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_005",
 			"component" : TMP_CA994EA13A81E463652C4B21610DAB80_AZL3I6CHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_005
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js